import Immutable from 'immutable';
import {local} from '../services/local';

import {TUTORIAL_COMPLETED} from '../actions/testroom';

const initialState = Immutable.fromJS({
  tutorialCompleted: false
});

export default function(state = initialState, action) {
  switch (action.type) {
    case TUTORIAL_COMPLETED:
      return state.set('tutorialCompleted', true);
    default:
      return state;
  }
}

export function getTutorialState(state) {
  return (
    local.get('tutorialCompleted') ||
    state.getIn(['testroom', 'tutorialCompleted'])
  );
}
